module.exports = __webpack_public_path__ + "img/hotel-13a.755ae077.jpeg";